import React from 'react';

// import interfaces
import {IFormFieldProps} from './../formProps';

// import subcomponents
import FieldHeader from './../sub/fieldHeader';
import FieldFooter from './../sub/fieldFooter';

// import services
import Validation from './../services/validation';

// import fabric ui components
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

interface IFEPasswordFieldState {
    field: IFormFieldProps;
    fields: IFormFieldProps[];
}

interface IFEPasswordFieldProps extends IFEPasswordFieldState {
    onValueChanged(key:string, value:string, errorMessage?:string): void;
}

export default class FEPasswordField extends React.Component<IFEPasswordFieldProps, IFEPasswordFieldState> {
    constructor(props:IFEPasswordFieldProps) {
        super(props);

        let {field, fields} = this.props;
        this.state = {
            field,
            fields
        }
    }

    public componentWillReceiveProps(props:IFEPasswordFieldProps) {
        this.setState({field: props.field});
    }

    private _onTextFieldChanged = (evt?:any, value?:string) => {
        let {field, fields} = this.state;
        let error = Validation.field(field, value, fields);
        this.props.onValueChanged(field.key, value || "", error);
    }

    public render() {
        let {field} = this.state;
        return (
            <Stack tokens={{childrenGap: 5}}>
                <Stack.Item>
                    <FieldHeader title={field.title} required={field.isRequired} content={field.content}/>
                </Stack.Item>
                <Stack.Item>
                    <TextField disabled={field.isDisabled} value={field.value || ""} type={"password"} onChange={this._onTextFieldChanged}/>
                </Stack.Item>
                <Stack.Item>
                    <FieldFooter error={field.errorMessage} description={field.description}/>
                </Stack.Item>
            </Stack>
        );
    }
}